export default __webpack_public_path__ + "static/media/full_12.1cd11451.jpg";